import { APIError } from '@/plugins/api/error'
import { ApiAbortedError } from '@/plugins/api/openapi/errors'

export function isUnauthorized(error: unknown) {
  return error instanceof APIError && error.code == 401
}

export function isRequestAborted(error: unknown) {
  return error instanceof ApiAbortedError
}
